import api from './api';
class DatosService {
    // Obtener declaración djb
    getDatosAbiertosDjb(params) {
        return api.get('/api/consultas/declaraciones-djb', { params });
    }
    // Obtener declaración djci
    getDatosAbiertosDjci(params) {
        return api.get('/api/consultas/declaraciones-djci', { params });
    }
    // Descargar PDF DJB
    downloadDjbPDF(id) {
        return api.get('/api/consultas/djb-descargarpdf/' + id, { responseType: 'blob' });
    }
    // Descargar PDF DJCI
    downloadDjciPDF(id) {
        return api.get('/api/consultas/djci-descargarpdf/' + id, { responseType: 'blob' });
    }
    // Descargar JSON DJB
    downloadDjbJSON(id) {
        return api.get('/api/consultas/djb-descargarjson/' + id);
    }
    // Descargar JSON DJCI
    downloadDjciJSON(id) {
        return api.get('/api/consultas/djci-descargarjson/' + id);
    }
}
export default new DatosService();